import {commitMutation, ConnectionHandler, graphql} from 'react-relay'
import type {Environment, RecordSourceSelectorProxy} from 'relay-runtime'

import type {
  RemoveLabelsFromLabelableInput,
  removeLabelsFromLabelableMutation,
  removeLabelsFromLabelableMutation$data,
} from './__generated__/removeLabelsFromLabelableMutation.graphql'

export function commitRemoveLabelsFromLabelable({
  environment,
  input,
  onError,
  onCompleted,
}: {
  environment: Environment
  input: RemoveLabelsFromLabelableInput
  onError?: (error: Error) => void
  onCompleted?: (response: removeLabelsFromLabelableMutation$data) => void
}) {
  const updater = (store: RecordSourceSelectorProxy<removeLabelsFromLabelableMutation$data>) => {
    const connectionId = ConnectionHandler.getConnectionID(input.labelableId, 'MetadataSectionAssignedLabels_labels')
    const connection = store.get(`${connectionId}(orderBy:{"direction":"ASC","field":"NAME"})`)
    if (connection && input.labelIds[0]) {
      ConnectionHandler.deleteNode(connection, input.labelIds[0])
    }
  }
  return commitMutation<removeLabelsFromLabelableMutation>(environment, {
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    mutation: graphql`
      mutation removeLabelsFromLabelableMutation($input: RemoveLabelsFromLabelableInput!) @raw_response_type {
        removeLabelsFromLabelable(input: $input) {
          clientMutationId
        }
      }
    `,
    variables: {
      input,
    },
    onError: error => onError && onError(error),
    onCompleted: response => onCompleted && onCompleted(response),
    updater,
    optimisticUpdater: updater,
  })
}
